export function isAuthorized<User>({
  mapUser,
  requireStrongAuthentication,
}: {
  mapUser: (user: User) => {
    email?: string;
    hasStrongAuthentication?: boolean;
    impersonatorEmail?: string;
    impersonatorUserToken?: string;
    isInitialMultiFactorAuthenticationRequired?: boolean;
    isLoggedIn: boolean;
    roles?: Array<string>;
    userToken?: string;
  };
  requireStrongAuthentication?: boolean;
}) {
  return (user: User) => {
    const {
      email,
      hasStrongAuthentication,
      impersonatorEmail,
      impersonatorUserToken,
      isInitialMultiFactorAuthenticationRequired,
      isLoggedIn,
      userToken,
    } = mapUser(user);

    const isImpersonating = impersonatorEmail && impersonatorUserToken;

    if (!isLoggedIn || (!isImpersonating && isLoggedIn && !email && !userToken)) {
      return false;
    } else if (isImpersonating) {
      return true;
    } else if (isInitialMultiFactorAuthenticationRequired) {
      return false;
    } else if (requireStrongAuthentication && !hasStrongAuthentication) {
      return false;
    } else {
      return true;
    }
  };
}
